import { useCallback } from 'react'

import { TrackEvent, useTracking } from '../../../apps/professional-app/fa/common/tracking'

export type CrossClientActionScope = 'recommended' | 'manual bulk' | 'single'

export interface ActionTracking {
  platform: string
  action: string
  scope: CrossClientActionScope
}

export const useActionTracking = (scope: CrossClientActionScope) => {
  const { trackingClient } = useTracking()

  const trackActionClicked = useCallback(
    (platform: string, action: string) => {
      trackingClient.track({ eventName: TrackEvent.X_CLIENT_ACTIONS_CLICKED, eventDetails: { platform, action, scope } })
    },
    [trackingClient, scope],
  )

  return { trackActionClicked }
}
